import React from "react";
import NewsletterForm from "./NewsletterForm";

/** Mobile-only newsletter strip between Presskit and News */
export default function MobileNewsletterStrip() {
  return (
    <section
      id="newsletter"
      className="md:hidden relative overflow-hidden py-10 px-6 text-white"
      aria-label="Newsletter"
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(160deg, #4a2a38 0%, #2a2132 55%, #3a2430 100%)",
        }}
      />
      <div className="absolute inset-0 tf-noise" />
      <div className="relative z-10 max-w-md mx-auto">
        <div
          className="rounded-xl bg-black/55 backdrop-blur-md border border-white/10 p-5 shadow-lg shadow-black/25"
          style={{ boxShadow: `0 12px 40px rgba(0,0,0,0.25)` }}
        >
          <h3 className="text-xl font-semibold mb-1 tracking-wide">
            JOIN OUR NEWSLETTER
          </h3>
          <p className="text-sm text-white/70 mb-4">
            Dev updates and announcements — no spam.
          </p>
          <NewsletterForm />
        </div>
      </div>
    </section>
  );
}
